import Glide from "@glidejs/glide";
import { FC } from "react";
import { useEffect, useRef } from "react";
import quotationImg from "images/quotation.png";
import quotationImg2 from "images/quotation2.png";

import useNcId from "hooks/useNcId";
import { useData } from "data/data-provider";
import { isUsableUrl } from "utils/isUsableUrl";

export interface SectionClientSayProps {
  className?: string;
  uniqueClassName: string;
}

const SectionTestimonials: FC<SectionClientSayProps> = ({
  className = "",
  uniqueClassName = "",
}) => {
  const { testimonials } = useData();
  const UNIQUE_CLASS = `SectionClientSay_glide_${uniqueClassName}` + useNcId();
  const glideRef = useRef<any>(null);

  useEffect(() => {
    if (document.querySelector(`.${UNIQUE_CLASS}`)) {
      setTimeout(() => {
        const glide = new Glide(`.${UNIQUE_CLASS}`, {
          perView: 1,
        });
        glideRef.current = glide;

        // Function to update height
        const updateHeight = () => {
          const activeSlide = document.querySelector(
            `.${UNIQUE_CLASS} .glide__slide--active`
          ) as HTMLElement;
          const track = document.querySelector(
            `.${UNIQUE_CLASS} .glide__track`
          ) as HTMLElement;
          if (activeSlide && track) {
            track.style.height = activeSlide.offsetHeight + "px";
          }
        };

        glide.on(["mount.after", "run.after"], updateHeight);
        glide.mount();

        // Initial height set
        setTimeout(updateHeight, 20);

        // Clean up
        return () => {
          glide.destroy();
        };
      }, 10);
    }
  }, []);

  return (
    <div
      className={`nc-SectionClientSay relative ${className} `}
      data-nc-id="SectionClientSay"
    >
      <div
        className={`nc-Section-Heading relative flex flex-col sm:flex-row sm:items-end justify-between ${className}`}
      >
        <div className={"text-center w-full max-w-2xl mx-auto"}>
          <span className={`leading-none text-2xl font-semibold`}>
            <span className="text-text-color" dangerouslySetInnerHTML={{ __html: testimonials?.heading }} />
          </span>
        </div>
      </div>
      {testimonials?.keypoints?.length > 0 && (
        <div className="relative md:mb-16 max-w-2xl mx-auto">
          <div className={`mt-12 lg:mt-16 relative ${UNIQUE_CLASS}`}>
            <img
              className="opacity-50 md:opacity-100 absolute -mr-16 lg:mr-3 right-full top-1"
              src={quotationImg}
              alt=""
            />
            <img
              className="opacity-50 md:opacity-100 absolute -ml-16 lg:ml-3 left-full top-1"
              src={quotationImg2}
              alt=""
            />
            <div className="glide__track " data-glide-el="track">
              <ul className="glide__slides ">
                {testimonials?.keypoints?.map((item: any, index: any) => (
                  <li
                    key={index}
                    className="glide__slide flex flex-col items-center text-center"
                  >
                    {isUsableUrl(item?.image_url) && (
                      <img
                        src={item.image_url}
                        alt=""
                        onError={(e) => {
                          (e.currentTarget as HTMLImageElement).style.display =
                            "none";
                        }}
                        className="w-24 h-24 rounded-full mb-4"
                      />
                    )}

                    <span className="block leading-none text-2xl text-secondary-text-color">
                     <span dangerouslySetInnerHTML={{ __html:item?.description }} />
                    </span>
                    <span
                      className={`block ${
                        item.image_url ? "mt-8" : ""
                      } leading-none font-semibold text-2xl text-secondary-text-color`}
                    >
                      <span dangerouslySetInnerHTML={{ __html: item?.heading }} />
                    </span>
                  </li>
                ))}
              </ul>
            </div>
            <div
              className="mt-10 glide__bullets flex items-center justify-center"
              data-glide-el="controls[nav]"
            >
              {testimonials?.keypoints?.map((item: any, index: any) => (
                <button
                  key={index}
                  className="glide__bullet w-2 h-2 rounded-full bg-neutral-300 mx-1 focus:outline-none"
                  data-glide-dir={`=${index}`}
                ></button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SectionTestimonials;
